// React.
import { useMemo } from 'react';

// Types.
import { TempDbSpaceTime } from '../../../types/instance/TempDb';

// Components.
import EChartsWithData from '../../chart/echarts/EChartsWithData';
import { EChartTimeSeries } from '../../chart/echarts/types';

// Helpers.
import { getConvertedTimeToUTC } from '../../../helpers/utils';

// Constants.
import { TARGET_COLOUR_CODES, CHART_DATA_TYPE, OTHER_COLOUR_CODE } from "../../Constants";

const RESERVED_METRICS: { name: string, field: string }[] = [
    { name: 'Version store reserved', field: 'versionstorereservedpagecount' },
    { name: 'User object reserved', field: 'userobjectreservedpagecount' },
    { name: 'Internal object reserved', field: 'internalobjectreservedpagecount' },
    { name: 'Mixed extent', field: 'mixedextentpagecount' },
    { name: 'Modified extent', field: 'modifiedextentpagecount' },
];

const LABELLED_AXIS = [{ labels: true }];

export default function TempDbSpaceChart(props: { error: string | null, loading: boolean, data: TempDbSpaceTime[] }) {
    const { error, loading, data } = props;

    const series = useMemo<EChartTimeSeries[]>(() => [
        ...RESERVED_METRICS.map((metric, index) => ({
            name: metric.name,
            chartType: 'bar' as const,
            color: TARGET_COLOUR_CODES[index],
            data: data.map((item: any): [number, number] => [getConvertedTimeToUTC(item), item[metric.field]]),
        })),
        {
            name: 'Total',
            chartType: 'line' as const,
            color: OTHER_COLOUR_CODE,
            data: data.map((item: any): [number, number] => [getConvertedTimeToUTC(item), item['totalpagecount']]),
        },
    ], [data]);

    return (
        <div className="card collapsible">
            <div className="card-header">
                <i className="fal fa-chart-bar fa-fw" aria-hidden="true"/>
                Space (pages)
                <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                   data-bs-target="#collapse-space" aria-expanded="false"
                   aria-controls="collapse-space"/>
            </div>
            <div id="collapse-space" className="card-body collapse show">
                <EChartsWithData error={error} loading={loading} length={data.length}
                                 series={series} tooltipType={CHART_DATA_TYPE.GENERIC}
                                 legend={true} yAxis={LABELLED_AXIS}/>
            </div>
        </div>
    )
}
